import React from 'react'
import { T } from '@transifex/react'

import { pathJoin } from 'src/reducers/routing/utils'

export const createImportsRoutesMap = (prefix: string) => ({
  ':id': (id = ':id') =>
    pathJoin(prefix)(id).chainWithTitle({
      title: <T _str="Import Details" />,
      breadCrumbTitle: <T _str="Import Details" />,
    }),
})
